module.exports = __webpack_public_path__ + "img/fractal-vein.39da3734.png";